/**
 * Calculates the center point (average x and y) of four fabric.Points.
 *
 * @param coords - An array of four fabric.Points.
 * @returns The center point as an object with x and y properties.
 */
export const calculateFabricCoordsCenter = (
  coords: [fabric.Point, fabric.Point, fabric.Point, fabric.Point],
): { x: number; y: number } => {
  return coords.reduce((acc, pt) => ({ x: acc.x + pt.x / 4, y: acc.y + pt.y / 4 }), { x: 0, y: 0 });
};
